/* eslint-disable no-shadow */
import React from 'react';
import PropTypes, { any } from 'prop-types';

import Description from '../../../components/text/Description';
import AvatarV2 from '../../../components/cards/PlayerCard/ListViewComponents/AvatarV2';
import { bucketWildcardTags as wildcardTags } from '../../../utils/eventConstants';

import styles from '../drawEdit.scss';

const PlayersForCheckInItem = (props) => {
    const {
        player,
        showHighSchoolName,
        handleSelectPlayerForCheckIn,
    } = props;

    const description = [
        ...(player.acceptanceListWildcardStateId ? [wildcardTags[player.acceptanceListWildcardStateId]] : []),
        player.gender,
        showHighSchoolName && player.highSchool ? player.highSchool : player.location,
    ];

    return (
        <div className={`item ${styles.allPlayersItem} check-in-item`} key={player.memberId} data-testid={`check-in.player-${player.memberId}`}>
            <div className="row">
                <div className={`col-md-9 d-flex aic p0`}>
                    <div className={`col-md-3 d-flex ais`}>
                        <AvatarV2
                            playerImages={player.playerProfileImages}
                            player={player}
                            className={styles.avatar}
                        />
                        <div className="player-details">
                            <div className="name text-dark" data-testid={`check-in.player-${player.memberId}.name`}>{player.firstName} {player.lastName}</div>
                            <div className="location text-normal text-gray">
                                <Description desc={description} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-flex ais">
                        <div className="player-details">
                            <div className="name text-dark fw300" data-testid={`check-in.player-${player.memberId}.age`}>
                                {player?.age || '-'}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 d-flex ais overflow-hidden">
                        <div className="player-details overflow-hidden">
                            {!!player.phone && (
                                <div className="location text-dark clickable ellipsis fw300" title={player.phone} onClick={(e) => copyToClipboard(e, player.phone)} data-testid={`check-in.player-${player.memberId}.phone`}>
                                    {player.phone}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-3 d-flex ais overflow-hidden">
                        <div className="player-details overflow-hidden">
                            {!!player.email && (
                                <div className="name text-dark clickable ellipsis fw300" title={player.email} onClick={(e) => copyToClipboard(e, player.email)} data-testid={`check-in.player-${player.memberId}.email`}>
                                    {player.email}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={`col-md-3 draws-list d-flex flex-column jcc`}>
                        {player.draws?.length ? (
                            <>
                                {player.draws.map(draw => (
                                    <div key={`${player.memberId}-${draw?.drawId}`} title={draw?.drawName} className="fw300 ellipsis" data-testid={`check-in.player-${player.memberId}.draw-${draw?.drawId}`}>
                                        {draw?.checkedIn && <span className="utr-icon icon-check-mark-green mr4 checkin-mark" title="Player checked in" />}
                                        {draw?.drawName}
                                    </div>
                                ))}
                            </>
                        )
                            : <span className="text-error" data-testid={`check-in.player-${player.memberId}.not-in-draw`}>Not in draw</span>}
                    </div>
                </div>
                <div className="col-md-3 d-flex aic p0">
                    <div className="row d-flex flex-1 aic">
                        <div className="col-md-2 d-flex ais text-dark fw300">
                            {player.draws?.length ? (
                                <div className="d-flex flex-col">
                                    {player.draws.map(draw => (
                                        <div key={`${player.memberId}-${draw.drawId}-ct`} className="fw300" data-testid={`check-in.player-${player.memberId}.court-${draw.drawId}`}>
                                            {draw?.courtName?.replace('Court ', '') || '-'}
                                        </div>
                                    ))}
                                </div>
                            ) : '-'}
                        </div>
                        <div className="col-md-6 d-flex ais text-dark fw300">
                            {player.draws?.length ? (
                                <div className="d-flex flex-col oh">
                                    {player.draws.map(draw => {
                                        const hasPartner = draw.partner?.firstName && draw.partner?.lastName;
                                        const partnerName = hasPartner ? `${draw.partner?.firstName} ${draw.partner?.lastName}` : '-';
                                        return (
                                            <div key={`${player.memberId}-${draw.drawId}-partner`} className="fw300 ellipsis pr8" data-testid={`check-in.player-${player.memberId}.partner-${draw.drawId}`}>
                                                {partnerName}
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : '-'}
                        </div>
                        <div className="col-md-4 d-flex aic jcfe">
                            <button
                                type="button"
                                className={`btn btn-default btn-sm text-uppercase mr12`}
                                disabled={false}
                                onClick={() => {
                                    handleSelectPlayerForCheckIn(player);
                                }}
                                data-testid={`check-in.player-${player.memberId}.check-in-btn`}
                            >
                                CHECK IN
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PlayersForCheckInItem.propTypes = {
    player: PropTypes.objectOf(any).isRequired,
    handleSelectPlayerForCheckIn: PropTypes.func.isRequired,
    showHighSchoolName: PropTypes.bool,
};

PlayersForCheckInItem.defaultProps = {
    showHighSchoolName: false,
};

export default React.memo(PlayersForCheckInItem);
